import React from 'react';
import { Play, Trophy } from 'lucide-react';

const WinnerCupPage = () => {
  const rows = [
    {
      id: 1,
      date: '02/11/2025',
      time: '00:00',
      title: 'ICC Womens Cricket Wo',
      odds: { one: '-', x: '-', two: '-' }
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 py-3 sm:py-6">
        {/* Most Popular */}
        <div className="bg-orange-500 rounded-lg p-3 sm:p-4 mb-3 sm:mb-4">
          <div className="flex items-center gap-2 sm:gap-3">
            <Play className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
            <h2 className="text-white font-bold text-base sm:text-lg">Most Popular</h2>
          </div>
        </div>

        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="flex items-center justify-between px-3 sm:px-4 py-2 sm:py-3 border-b">
            <div className="flex items-center gap-2 sm:gap-3">
              <Trophy className="w-5 h-5 sm:w-6 sm:h-6 text-yellow-500" />
              <h1 className="text-lg sm:text-2xl font-bold text-gray-900">Winner Cup</h1>
            </div>
            <div className="hidden sm:flex items-center gap-6 sm:gap-10 text-sm font-bold text-gray-900">
              <span>1</span>
              <span>X</span>
              <span>2</span>
            </div>
          </div>

          {/* Row header for mobile */}
          <div className="sm:hidden grid grid-cols-3 gap-1 px-3 py-2 text-xs font-bold text-gray-900 border-b">
            <span>1</span><span className="text-center">X</span><span className="text-right">2</span>
          </div>

          {/* Table */}
          <div>
            {rows.map((r) => (
              <div key={r.id} className="grid grid-cols-1 sm:grid-cols-4 gap-0 border-b last:border-b-0">
                {/* date */}
                <div className="px-3 py-3 text-xs sm:text-sm text-green-600 font-medium border-r">
                  {r.date}\n{r.time}
                </div>
                {/* title */}
                <div className="px-3 py-3 text-sm sm:text-base text-gray-900 sm:border-r">
                  {r.title}
                </div>
                {/* odds */}
                <div className="px-0 py-0 sm:px-3 sm:py-3 sm:border-r">
                  <div className="h-full bg-blue-100 sm:rounded-none rounded-none flex items-center justify-center text-sm font-semibold text-gray-900">
                    {r.odds.one}
                  </div>
                </div>
                <div className="px-0 py-0">
                  <div className="h-full bg-blue-100 flex items-center justify-center text-sm font-semibold text-gray-900">
                    {r.odds.x}
                  </div>
                </div>
                <div className="hidden" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WinnerCupPage;


